import {
  CommandBar,
  Link,
  MessageBar,
  MessageBarType,
  Pivot,
  PivotItem,
  PivotLinkSize,
  ProgressIndicator,
  SearchBox,
} from "@fluentui/react";
import { Layout, message, Badge, notification, Tooltip } from "antd";

import React, { createContext, useContext, useRef } from "react";
import moment from "moment";

import MonthlyPerformanceStore from "./store/monthlyperformancestore";
import { observer } from "mobx-react-lite";

import { AgGridReact } from "ag-grid-react";
import formatNumber from "accounting-js/lib/formatNumber";
import { FileExcelOutlined } from "@ant-design/icons";
import { toJS } from "mobx";

const { Content } = Layout;
const _ = require("underscore");

const MonthlyPerformanceStoreCtx = createContext(MonthlyPerformanceStore);

export const MonthlyReviewGrid = observer(() => {
  const monthlyPerformanceStore = useContext(MonthlyPerformanceStoreCtx);
  const reviewImportGrid = useRef(null);
  const formatDigit = (params) => {
    const { value } = params;
    // this puts commas into the number eg 1000 goes to 1,000,
    // i pulled this from stack overflow, i have no idea how it works
    if (value) {
      return formatNumber(value, {
        thousand: ",",
      });
    }
  };
  const getTotal = (col) => {
    const data = _.pluck(
      [...monthlyPerformanceStore.reviewData.values()].map((d) => toJS(d)),
      col
    );
    console.log("data", data);
    const sum = _.reduce(
      data,
      function (memo, num) {
        return (
          Number(memo) + Number(_.isNull(num) || _.isUndefined(num) ? 0 : num)
        );
      },
      0
    );

    return sum;
  };

  const gridcolumnDefs = {
    columnDefs: [
      {
        headerName: "#",
        valueGetter: "node.rowIndex + 1",
        width: 30,
        resizable: true,
        sortable: true,
        pivot: false,
      },
      {
        width: 30,
        hide: true,
        pivot: false,
        resizable: true,
      },
      {
        headerName: "HIERARCHY",

        children: [
          {
            headerName: "UNIQUE ID",
            field: "uniqueId",
            sortable: true,
            resizable: true,

            filter: true,
            width: 120,
          },
          {
            headerName: "FIELD",
            field: "field",
            sortable: true,
            resizable: true,

            filter: true,
            width: 120,
          },
          {
            headerName: "WELL",
            field: "well",
            sortable: true,
            resizable: true,
            filter: true,
            width: 100,
          },
          {
            headerName: "LEVEL",
            field: "level",
            filter: true,
            sortable: true,
            resizable: true,
            width: 80,
          },
        ],
      },
      {
        headerName: "DAYS",
        field: "days",
        sortable: true,
        resizable: true,
        width: 80,
      },
      {
        headerName: "Month Produced",
        field: "numMonthProduced",
        sortable: true,
        resizable: true,
        width: 80,
      },

      {
        headerName: 'CHOKE (1/64)"',
        field: "choke",
        filter: true,
        width: 80,
        sortable: true,
        resizable: true,
      },

      {
        headerName: "FTHP",
        field: "fthp",
        sortable: true,
        resizable: true,
        width: 120,
      },

      {
        headerName: "BSW",
        field: "bsw",
        sortable: true,
        resizable: true,

        width: 150,
      },

      {
        headerName: "API",
        field: "api",
        sortable: true,
        resizable: true,

        width: 150,
      },
      {
        headerName: "  GOR ",

        children: [
          {
            headerName: "Initial",

            field: "initialGOR",
            sortable: true,
            resizable: true,

            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },

          {
            headerName: "Producing",

            field: "producingGOR",
            sortable: true,
            resizable: true,

            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },
        ],
      },

      {
        headerName: "TYPE",
        field: "type",
        sortable: true,
        resizable: true,

        width: 80,
      },
      {
        headerName: "DATE LAST PRODUCTION.",
        field: "dateLastProduced",
        sortable: true,
        resizable: true,
        width: 120,
        cellRenderer: function (props) {
          if (
            _.isEmpty(props.data.dateLastProduced) ||
            _.isNull(props.data.dateLastProduced) ||
            _.isUndefined(props.data.dateLastProduced)
          ) {
            return "";
          }
          return moment(props.data.dateLastProduced).format("D-MMM-YY");
        },
        pinnedRowCellRenderer: (props) => {
          return "Sum Total";
        },
      },
      {
        headerName: "MONTHLY PRODUCTION",

        children: [
          {
            headerName: "OIL (stb)",
            field: "oil",
            cellStyle: { textAlign: "center", backgroundColor: "#ffcdd2" },

            width: 100,
            sortable: true,
            resizable: true,

            type: "numberColumn",
            valueFormatter: formatDigit,
            /*  pinnedRowCellRendererParams: {
              style: { color: "red" },
            },
            pinnedRowCellRenderer: (props) => {
              return monthlyPerformanceStore.totalOil;
            }, */
          },
          {
            headerName: "GAS (Mscf)",
            field: "gas",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#C8E6C9",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },
          {
            headerName: "WATER (stb)",

            field: "water",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#FFECB3",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },

          {
            headerName: "Oil Cummulative (stb)",
            hide: true,
            field: "cumOil",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#E2E9EB",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },

          {
            headerName: "Gas Cummulative (Mscf)",
            hide: true,
            field: "cumGas",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#E2E9EB",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },
          {
            headerName: " Cummulative Water Prod (stb)",
            hide: true,
            field: "cumWater",
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#E2E9EB",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },

          {
            headerName: "OIL (stb/d)",
            field: "oilRate",
            cellStyle: { textAlign: "center", backgroundColor: "#E2E9EB" },
            hide: true,
            width: 100,
            sortable: true,
            resizable: true,

            type: "numberColumn",
            valueFormatter: formatDigit,
          },
          {
            headerName: "GAS (Mscf/d)",
            field: "gasRate",
            hide: true,
            sortable: true,
            resizable: true,
            cellStyle: {
              textAlign: "right",
              backgroundColor: "#E2E9EB",
            },
            width: 100,
            type: "numberColumn",
            valueFormatter: formatDigit,
          },
        ],
      },
      {
        headerName: "REMARKS",
        field: "remarks",
        sortable: true,
        resizable: true,

        width: 150,
      },
    ],
  };

  return (
    <Layout style={{ background: "#fff", marginTop: "10px" }}>
      <Content style={{ background: "#fff" }}>
        <div
          className="ms-Grid-row"
          style={{ background: "white", marginBottom: "5px" }}
        >
          <CommandBar
            items={[
              {
                onRender: () => (
                  <MessageBar messageBarType={MessageBarType.info}>
                    Cummulative productions and production rates will be
                    calculated from volumes by SPARS engine
                  </MessageBar>
                ),
              },
            ]}
            farItems={[
              {
                key: "search",
                onRender: () => (
                  <Tooltip title="smart quick search on the subsurface parameters data displayed">
                    <SearchBox
                      placeholder="Search"
                      styles={{
                        root: {
                          width: "100%",
                          borderBottomColor: "#CBD5E0",
                        },
                      }}
                      underlined={true}
                      onChange={(ev, searchTerms) => {
                        reviewImportGrid.current.api.setQuickFilter(
                          searchTerms
                        );
                        // const filterValue = grid.current.api.filterManager.quickFilter;
                      }}
                    ></SearchBox>
                  </Tooltip>
                ),
              },
              {
                key: "spacere",
                onRender: () => <div style={{ width: "100px" }} />,
              },
              {
                key: "group4",

                text: (
                  <Tooltip title="Export displayed production data to excel">
                    Export to Excel
                  </Tooltip>
                ),
                name: "group",
                onRenderIcon: () => <FileExcelOutlined className="qicon" />,

                onClick: async () => {
                  try {
                    monthlyPerformanceStore.isExporting = true;
                    await reviewImportGrid.current.api.exportDataAsExcel({
                      sheetName: monthlyPerformanceStore.gridHeaderText.replace(
                        "NAOC PRODUCTION",
                        "NAOCPROD"
                      ),
                      allColumns: true,

                      skipFooters: false,
                      skipGroups: false,
                      skipHeader: false,
                      skipPinnedTop: false,
                      skipPinnedBottom: false,
                      fileName: "naoc_monthly_production_parameter_data",
                      skipColumnGroupHeaders: false,
                      skipColumnHeaders: false,
                      columnGroups: true,
                    });
                  } catch (error) {
                    notification.error({
                      message: "SPARS Feedback",
                      description: "export failed",
                    });
                  } finally {
                    monthlyPerformanceStore.isExporting = false;
                  }
                },
              },
            ]}
          />
        </div>
        {monthlyPerformanceStore.isDownloadingTemplate && (
          <div className="ms-Grid-row">
            <div className="ms-Grid-col ms-sm12">
              <ProgressIndicator
                description="downloading template,please wait..."
                styles={{ root: { textAlign: "center" } }}
              ></ProgressIndicator>
            </div>
          </div>
        )}
        <div
          className="ag-theme-balham qikreach-grid-fill"
          style={{
            minHeight: "50vh",
            height: "100vh",
            width: "100%",
            maxHeight: "80vh",
          }}
        >
          <AgGridReact
            rowData={[...monthlyPerformanceStore.reviewData.values()]}
            sideBar={["filters"]}
            ref={reviewImportGrid}
            gridOptions={{
              defaultColDef: {
                sortable: true,
                filter: true,
                enableValue: true,
                enableRowGroup: true,
              },
              enableCharts: true,
              enableRangeSelection: true,

              rowSelection: "single",
              pagination: true,
              columnDefs: gridcolumnDefs.columnDefs,
              animateRows: true,
              statusBar: {
                statusPanels: [
                  {
                    statusPanel: "agTotalRowCountComponent",
                    align: "center",
                  },
                ],
              },
              columnTypes: {
                numberColumn: {
                  width: 130,
                  filter: "agNumberColumnFilter",
                },
                medalColumn: {
                  width: 100,
                  columnGroupShow: "open",
                  filter: false,
                },
                nonEditableColumn: { editable: false },
                dateColumn: {
                  filter: "agDateColumnFilter",
                  filterParams: {
                    comparator: function (
                      filterLocalDateAtMidnight,
                      cellValue
                    ) {
                      var dateParts = cellValue.split("/");
                      var day = Number(dateParts[0]);
                      var month = Number(dateParts[1]) - 1;
                      var year = Number(dateParts[2]);
                      var cellDate = new Date(year, month, day);
                      if (cellDate < filterLocalDateAtMidnight) {
                        return -1;
                      } else if (cellDate > filterLocalDateAtMidnight) {
                        return 1;
                      } else {
                        return 0;
                      }
                    },
                  },
                },
              },
            }}
            rowSelection={{ mode: "multiRow", checkboxes: true, headerCheckbox: true, enableClickSelection: true, enableSelectionWithoutKeys: true }}
            copyHeadersToClipboard={true}
            overlayLoadingTemplate={`${(
              <span class="ag-overlay-loading-center">
                Please wait while your rows are loading
              </span>
            )}`}
            overlayNoRowsTemplate={
              '<span style="padding: 10px; border: 2px solid #444; background: lightgoldenrodyellow;">No Result,Proceed to Import</span>'
            }
            pinnedBottomRowData={[
              {
                oil: getTotal("oil"),
                gas: getTotal("gas"),
                water: getTotal("water"),
              },
            ]}
          ></AgGridReact>
        </div>
      </Content>
    </Layout>
  );
});

